import { logger as N } from "../../shared-lib/index.js";
import r from "../managers/braze-instance.js";
import ve from "../models/braze-event.js";
import F from "../models/request-result.js";
var c = {
  ut: function ut(e, o, t) {
    var n, s;
    var i = new F(),
        l = r.P();
    if (!l) return N.info("Not logging event with type \"".concat(e, "\" because the current session ID could not be found.")), i;
    var d = l.Qo();
    return i.$e.push(new ve(t || (null === (n = r.ir()) || void 0 === n ? void 0 : n.getUserId()), e, new Date().valueOf(), d, o)), i.tt = (null === (s = r.j()) || void 0 === s ? void 0 : s.Vo(i.$e)) || !1, i;
  }
};
export default c;